module.exports = __webpack_public_path__ + "img/folded-paper-map-of-world-with-color-point-marker-illustration-vector (1).1d39e5ee.jpg";